import React, { useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import html2pdf from "html2pdf.js";

const GetPdf = () => {

    const [empId, setEmpId] = useState("");
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);

    /* ================= FETCH REPORT ================= */
    const fetchReport = async () => {

        if (!empId) {
            alert("Enter Employee Code");
            return;
        }

        try {
            setLoading(true);

            const response = await fetch(
                `https://pms.vdcapp.in/backend/pms_employee_report/${empId}`
            );

            const result = await response.json();

            console.log("API RESPONSE :", result); // debug once

            if (result?.status && result?.data?.employee_details) {

                setReportData({
                    employee: result.data.employee_details,
                    written: result.data.current_year_written_questions || [],
                    viva: result.data.current_year_viva_questions || []

                });

                setTimeout(() => {
                    openPDF();   // ✅ AUTO OPEN PDF
                }, 500);

            } else {
                alert("No record found");
                setReportData(null);
            }

        } catch (error) {
            console.error(error);
        }

        setLoading(false);
    };

    /* ================= DOWNLOAD PDF ================= */
    const openPDF = () => {
        const element = document.getElementById("pdf-content");

        element.classList.add("pdf-mode"); // 👈 important

        const opt = {
            margin: 0.3,
            filename: `PMS_Report_${empId}.pdf`,
            html2canvas: { scale: 2 },
            jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "landscape"
            },
        };

        setTimeout(() => {
            html2pdf()
                .set(opt)
                .from(element)
                .outputPdf("bloburl")
                .then((url) => {
                    window.open(url, "_blank");
                    element.classList.remove("pdf-mode");
                });
        }, 400);
    };

    const formatDate = (date) => {
        if (!date) return "-";
        const [y, m, d] = date.split("-");
        return `${d}/${m}/${y}`;
    };

    const vivaCreatedBy = reportData?.viva?.[0]?.created_by || "-";
    const vivaCreatedByName = reportData?.viva?.[0]?.created_by_name || "-";

    // ================= CURRENT YEAR =================
    const currentWrittenTotal = reportData?.employee?.total_current_year_written_questions || 0;
    const currentWrittenScored = reportData?.employee?.total_current_year_written_scored || 0;

    const currentWrittenPercentage =
        currentWrittenTotal > 0
            ? ((currentWrittenScored / currentWrittenTotal) * 100).toFixed(2)
            : 0;

    const currentVivaTotal = reportData?.employee?.total_current_year_viva_questions || 0;
    const currentVivaScored = reportData?.employee?.total_current_year_viva_scored || 0;

    const currentVivaPercentage =
        currentVivaTotal > 0
            ? ((currentVivaScored / currentVivaTotal) * 100).toFixed(2)
            : 0;


    // ================= PREVIOUS YEAR =================
    const prevWrittenTotal = reportData?.employee?.total_previous_year_written_questions || 0;
    const prevWrittenScored = reportData?.employee?.total_previous_year_written_scored || 0;

    const prevWrittenPercentage =
        prevWrittenTotal > 0
            ? ((prevWrittenScored / prevWrittenTotal) * 100).toFixed(2)
            : 0;

    const prevVivaTotal = reportData?.employee?.total_previous_year_viva_questions || 0;
    const prevVivaScored = reportData?.employee?.total_previous_year_viva_scored || 0;

    const prevVivaPercentage =
        prevVivaTotal > 0
            ? ((prevVivaScored / prevVivaTotal) * 100).toFixed(2)
            : 0;
let rating_written = 0;
let rating_written_text = '';
let rating_viva = 0;
let rating_viva_text = '';
    if (currentWrittenPercentage >= 91) {
        rating_written = 5;
        rating_written_text = "OutStanding";
    } else if (currentWrittenPercentage >= 76 && currentWrittenPercentage <= 90) {
        rating_written = 4;
        rating_written_text = "Exceed Expectation";
    } else if (currentWrittenPercentage >= 56 && currentWrittenPercentage <= 75) {
        rating_written = 3;
        rating_written_text = "Meet Expectation";
    } else if (currentWrittenPercentage >= 41 && currentWrittenPercentage <= 55) {
        rating_written = 2;
        rating_written_text = "Below Expectation";
    } else if (currentWrittenPercentage <= 40) {
        rating_written = 1;
        rating_written_text = "Unsatisfactory";
    }

    if (currentVivaPercentage >= 91) {
        rating_viva = 5;
        rating_viva_text = "OutStanding";
    } else if (currentVivaPercentage >= 76 && currentVivaPercentage <= 90) {
        rating_viva = 4;
        rating_viva_text = "Exceed Expectation";
    } else if (currentVivaPercentage >= 56 && currentVivaPercentage <= 75) {
        rating_viva = 3;
        rating_viva_text = "Meet Expectation";
    } else if (currentVivaPercentage >= 41 && currentVivaPercentage <= 55) {
        rating_viva = 2;
        rating_viva_text = "Below Expectation";
    } else if (currentVivaPercentage <= 40) {
        rating_viva = 1;
        rating_viva_text = "Unsatisfactory";
    }


    return (
        <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />

                <div className="main-panel">
                    <div className="content-wrapper">

                        {/* SEARCH */}
                        <div className="card mb-3">
                            <div className="card-body d-flex gap-2">
                                <input
                                    className="form-control"
                                    placeholder="Enter Employee Code"
                                    value={empId}
                                    onChange={(e) => setEmpId(e.target.value)}
                                />

                                <button className="btn btn-primary" onClick={fetchReport}>
                                    Search
                                </button>

                                {reportData?.employee && (
                                    <button className="btn btn-success" onClick={openPDF}>
                                        Download PDF
                                    </button>
                                )}
                            </div>
                        </div>

                        {loading && <p>Loading...</p>}

                        {/* ================= PDF CONTENT ================= */}
                        {reportData?.employee && (
                            <div id="pdf-content" className="card p-4">

                                <h3 className="text-center mb-4">
                                    PMS Employee Report
                                </h3>

                                {/* EMPLOYEE DETAILS */}
                                <table
                                    className="table table-bordered"
                                    style={{
                                        tableLayout: "fixed",
                                        width: "100%",
                                        borderCollapse: "collapse"
                                    }}
                                >
                                    <tbody>

                                        <tr>
                                            <td style={{ width: "15%" }}><b>Emp ID</b></td>
                                            <td style={{ width: "35%" }}>{reportData?.employee?.emp_code || "-"}</td>
                                            <td style={{ width: "15%" }}><b>Name</b></td>
                                            <td style={{ width: "35%" }}>{reportData?.employee?.comp_name || "-"}</td>
                                        </tr>

                                        <tr>
                                            <td><b>Branch</b></td>
                                            <td>{reportData?.employee?.location_name || "-"}</td>
                                            <td><b>Reporting Manager</b></td>
                                            <td>
                                                {reportData?.employee?.report_manager_name || "-"}
                                                ({reportData?.employee?.report_mngr || "-"})
                                            </td>
                                        </tr>

                                        {/* ===== DOJ SECTION ===== */}
                                        <tr>
                                            <td><b>DOJ</b></td>

                                            <td>
                                                {formatDate(reportData?.employee?.doj)}
                                            </td>


                                            <td><b>Experience</b></td>
                                            <td>{reportData?.employee?.experience_years ?? "-"} Years</td>
                                        </tr>

                                        <tr>
                                            <td><b>Department</b></td>
                                            <td>{reportData?.employee?.dept_name || "-"}</td>
                                            <td><b>Viva Done By</b></td>
                                            <td>
                                                {vivaCreatedBy !== "-"
                                                    ? `${vivaCreatedBy} (${vivaCreatedByName})`
                                                    : "-"
                                                }
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                                {/* MARKS */}
                                <h4 className="mt-4">Written & Viva Rating Details</h4>

                                <table className="table table-bordered">
                                      <thead >
    <tr >
      <th style={{ backgroundColor: "#a39898d7" }}>Type</th>
      <th style={{ backgroundColor: "#a39898d7" }}>Total</th>
      <th style={{ backgroundColor: "#a39898d7" }}>Scored</th>
      <th style={{ backgroundColor: "#a39898d7" }}>Percentage</th>
      <th style={{ backgroundColor: "#a39898d7" }}>Rating</th>
    </tr>
  </thead>

                                    <tbody>
                                        {/* ===== CURRENT YEAR ===== */}
                                        <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
                                            <td colSpan="3">Current Year</td>
                                        </tr>

                                        <tr>
                                            <td>Written Exam</td>
                                            <td>{currentWrittenTotal}</td>
                                            <td>{currentWrittenScored}</td>
                                            <td>{currentWrittenPercentage}%</td>
                                            <td>{rating_written} ({rating_written_text})</td>
                                        </tr>

                                        <tr>
                                            <td>Viva</td>
                                            <td>{currentVivaTotal}</td>
                                            <td>{currentVivaScored}</td>
                                            <td>{currentVivaPercentage}%</td>
                                            <td>{rating_viva} ({rating_viva_text})</td>
                                        </tr>

                                        {/* ===== PREVIOUS YEAR ===== */}
                                        <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
                                            <td colSpan="3">Previous Year</td>
                                        </tr>

                                        <tr>
                                            <td>Written Exam</td>
                                            <td>
                                                {reportData?.employee?.total_previous_year_written_questions ?? 0}
                                            </td>
                                            <td>
                                                {reportData?.employee?.total_previous_year_written_scored ?? 0}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Viva</td>
                                            <td>
                                                {(reportData?.employee?.total_previous_year_viva_questions) * 5 ?? 0}
                                            </td>
                                            <td>
                                                {reportData?.employee?.total_previous_year_viva_scored ?? 0}
                                            </td>
                                        </tr>


                                    </tbody>
                                </table>

                                <h4 className="mt-4">Viva Reviewer Feedback</h4>

                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td><b>Overall Remarks</b></td>
                                            <td style={{
                                                width: "40%",
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                                overflowWrap: "anywhere",
                                                verticalAlign: "top"
                                            }}>{reportData?.employee?.overall_remarks || "-"}</td>
                                            <td><b>Feedback Remarks</b></td>
                                            <td>{reportData?.employee?.feedback_marks || "-"}</td>
                                        </tr>

                                        <tr>
                                            <td><b>Interview Feedback</b></td>
                                            <td>{reportData?.employee?.interviewer_feed_back || "-"}</td>
                                            <td><b>Training Needs</b></td>
                                            <td>{reportData?.employee?.training_needs || "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                {/* WRITTEN QUESTIONS */}
                                <h4 className="mt-4">Written Exam</h4>

                                <table
                                    className="table table-bordered"
                                    style={{ tableLayout: "fixed", width: "100%" }}
                                >
                                    <tbody>
                                        <tr><th style={{ width: "5%", verticalAlign: "top",backgroundColor: "#a39898d7" }}>S.No</th>
                                        <th style={{
                                                        width: "75%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top",
                                                        backgroundColor: "#a39898d7"
                                                    }}>Question</th>
                                        <th style={{
                                                        width: "35%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top",
                                                        backgroundColor: "#a39898d7"
                                                    }}>Correct Answer</th>
                                        <th style={{
                                                        width: "5%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top",
                                                        backgroundColor: "#a39898d7"
                                                    }}>Score</th>
                                        
                                        </tr>
                                        {reportData?.written?.map((q, i) => (
                                            <tr key={i}>
                                                <td style={{ width: "5%", verticalAlign: "top" }}>
                                                    {i + 1}
                                                </td>

                                                <td
                                                    style={{
                                                        width: "60%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top"
                                                    }}
                                                >
                                                    {q?.question}
                                                </td>

                                                <td
                                                    style={{
                                                        width: "35%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top"
                                                    }}
                                                >
                                                    {q?.emp_answer}
                                                </td>
                                                <td
                                                    style={{
                                                        width: "35%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top"
                                                    }}
                                                >
                                                    {q?.score}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div style={{ pageBreakBefore: "always" }}></div>

                                {/* VIVA QUESTIONS */}
                                <h4 className="mt-4">Viva Questions</h4>

                                <table
                                    className="table table-bordered"
                                    style={{ tableLayout: "fixed", width: "100%" }}
                                >
                                    <tbody>
                                        <tr><th style={{ width: "5%", verticalAlign: "top",backgroundColor: "#a39898d7" }}>S.No</th>
                                        <th style={{
                                                        width: "60%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top",backgroundColor: "#a39898d7"
                                                    }}>Question</th>
                                        <th style={{
                                                        width: "55%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top",backgroundColor: "#a39898d7"
                                                    }}>Correct Answer</th>
                                        <th style={{
                                                        width: "15%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top",backgroundColor: "#a39898d7"
                                                    }}>Status</th>
                                        <th style={{
                                                        width: "35%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top",backgroundColor: "#a39898d7"
                                                    }}>Remarks</th>
                                        </tr>
                                        {reportData?.viva?.map((v, i) => (
                                            <tr key={i}>
                                                <td style={{ width: "5%", verticalAlign: "top" }}>
                                                    {i + 1}
                                                </td>

                                                <td
                                                    style={{
                                                        width: "60%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top"
                                                    }}
                                                >
                                                    {v?.question}
                                                </td>

                                                <td
                                                    style={{
                                                        width: "35%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top"
                                                    }}
                                                >
                                                    {v?.answer}
                                                </td>
                                                <td
                                                    style={{
                                                        width: "35%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top"
                                                    }}
                                                >
                                                    {v?.answered_radio}
                                                </td>
                                                <td
                                                    style={{
                                                        width: "35%",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        verticalAlign: "top"
                                                    }}
                                                >
                                                    {v?.remarks}
                                                </td>
                                                
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>
                        )}

                    </div>

                    <footer className="footer text-center">
                        © {new Date().getFullYear()} Vijaya Diagnostic Centre
                    </footer>

                </div>
            </div>
        </div>
    );
};

export default GetPdf;